import { Loading } from "../Loading";
import s from "./PageLoading.module.css";

export function PageLoading() {
    return (
        <div className={s['page-loading']}>
            <Loading />
        </div>
    );
}